__turbopack_context__.v({
  "noVerticalPadding": "FFKniq_noVerticalPadding",
  "tabPanel": "FFKniq_tabPanel",
});
